export class UpdateFollowUp {
  id: number;
  financType: string;
  situation: string;
  quantity: number;
  obs: string;
  bankId: number;
  file: string;
  initQuantity: number;
  initSitCred: string;
  approval: string;

  constructor(id: any, financType: any, situation: any, qtd: any, obs: any, bankId: any, file: any,  initQtd: any, initSitCred: any, approval: any){
      this.id = id;
      this.financType = financType;
      this.situation = situation;
      this.quantity = qtd;
      this.obs = obs;
      this.bankId = bankId;
      this.file = file;
      this.initQuantity = initQtd;
      this.initSitCred = initSitCred;
      this.approval = approval ? approval : '';
    }
}

